// extracted by mini-css-extract-plugin
export default {"menu":"DurationTimeEditor_menu__2NrwD","menuButton":"DurationTimeEditor_menuButton__hhKmd","intersection":"DurationTimeEditor_intersection__+M4KJ"};